import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 7701BECC-343D-4BE8-B33A-B88ABACA8F26
 * name microsoft-azure
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-azure.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftAzureIcon = createSvgIcon(<><path d="M13.05,4.24L6.56,18.05L2,18L7.09,9.24L13.05,4.24M13.75,5.33L22,19.76H6.74L16.04,18.1L11.17,12.31L13.75,5.33Z" /></>, 'MicrosoftAzureIcon');
export default MicrosoftAzureIcon